/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateSetupIntentMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CreateSetupIntentMutation = {
  readonly __typename?: 'Mutation';
  readonly createPaymentIntent: string;
};

export const CreateSetupIntentDocument = gql`
  mutation CreateSetupIntent {
    createPaymentIntent
  }
`;

export function useCreateSetupIntentMutation() {
  return Urql.useMutation<
    CreateSetupIntentMutation,
    CreateSetupIntentMutationVariables
  >(CreateSetupIntentDocument);
}
